import { render, staticRenderFns } from "./PromptMagicButton.vue?vue&type=template&id=3dab444c"
import script from "./PromptMagicButton.vue?vue&type=script&lang=ts"
export * from "./PromptMagicButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports